export default __webpack_public_path__ + "static/media/check_icon.c53f9123.svg";